import React, { useRef } from "react";
import { bool, func } from "prop-types";
import { Trans, useTranslation } from "@lib/i18n";

import Modal from "../shared/Modal";

const SellerInfoModal = ({ isOpen, closeModal }) => {
  const { t } = useTranslation();

  const modalFirstElement = useRef(null);

  return (
    <Modal
      isOpen={isOpen}
      ariaLabel={t("footer.sellerInformationModal.heading")}
      firstElement={modalFirstElement}
      closeButtonDataId="seller-information-close-icon"
      onClose={closeModal}
      withCloseIcon
    >
      <div
        className="flex flex-col items-start h-full gap-4"
        data-id="seller-contact-modal"
      >
        <h4 className="text-xl font-semibold">
          {t("footer.sellerInformationModal.heading")}
        </h4>
        <p>
          <Trans i18nKey={"footer.sellerInformationModal.text"}>
            <a
              className="underline"
              href={t("footer.sellerInformationModal.link")}
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ link: t("footer.sellerInformationModal.link") }}
            </a>
          </Trans>
        </p>
      </div>
    </Modal>
  );
};

SellerInfoModal.propTypes = {
  isOpen: bool.isRequired,
  closeModal: func.isRequired,
};

export default SellerInfoModal;
